import type { FaireProductEntity } from "../../entity_types/product";

export const p_9qm53bpqrn: FaireProductEntity = {
  token: "p_9qm53bpqrn",
  type: "product",
  name: "Evelyn Open Front Knitted Cardigan",
  brandToken: "b_aikxxfpecb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1832f09c262e37ab2b8522e209be5190fe3f9a54e517cefcae90b3579e8acb6f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5aeae4ddfc2dfc59ddc168c7ff6eea4cb469e5834f1ea68a7a5b53c3cf99fd3e.jpeg",
    "https://cdn.faire.com/fastly/cf3eb21d8c51eea8457cf1d26205444ead439f0790158269f3910c36621d76c7.jpeg",
    "https://cdn.faire.com/fastly/7cfc7ffb8b7626ea38976a83d141dfe0aa9bbc870d858b188900c7b5428674e4.jpeg",
    "https://cdn.faire.com/fastly/c5a7e7fe7a9f31d5db8db3c32d88343290c3dfac4e06d412717703270ef17893.jpeg",
    "https://cdn.faire.com/fastly/0aeb7ccbaa78f15aa7ecfbe64ccd3ec5f620d1c5279d9b1cc7abcea2405893ff.jpeg",
    "https://cdn.faire.com/fastly/5653a5890eee937e6248ebab22d7e831d9f0e34789c3a1204b1bb6db45d9fb74.jpeg",
    "https://cdn.faire.com/fastly/d45899da37ce29f28c157fade243586b9dfd0c8fa1f792a2ff38f5c50c7c40c0.jpeg",
    "https://cdn.faire.com/fastly/07c5fbbf508b28316df896e96ae1bcba00c94dfe86ef26abcd0a780545e24760.jpeg",
    "https://cdn.faire.com/fastly/e5f8eecc3c0d4b5dc5569c48ddb6c9935df73fe2c41bca274657a6b4eccd7fcd.jpeg",
    "https://cdn.faire.com/fastly/2813f5ba7f59e192afa1236bc4590e058f3b7100f34f02c25ce5f37c3df2dd27.jpeg",
    "https://cdn.faire.com/fastly/634de901e8ae8f2014554477b4de9e8763fe0f38417410db018ac0df4599b1c7.jpeg",
    "https://cdn.faire.com/fastly/18521f4917bbb89df02f15202b6d90c0bee47ed0e950115144acb90dec79aec6.png",
  ],
  priceDollars: 40.5,
  description:
    "Meet Evelyn Open Front Knitted Cardigan—effortless, flattering, and easy to style for everyday life. Aztec print in the cardigan is very stylish and unique Open front cardigan with long sleeve set off your perfect curve Knitted design makes the cardigan more delicate and textured Wearing it to pair with your chic tops and bottoms for a laid-back look Women's cardigans are perfect for daily wear, date, trip, party\n\nMaterial: 48%Acrylic+28%Nylon+24%Rayon.\n",
  tags: [],
  msrpDollars: 81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:06.252Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
